import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { addTaskIcon } from '@/assets/images';
import BasicPageTitle from '@/components/common/BasicPageTitle';
import FilterButton from '@/components/common/FilterButton';
import ShowForViews from '@/components/common/ShowForViews';
import MultiActionDialogKey from '@/constants/MultiActionDialogKey';
import UserViewEnums from '@/constants/users/UserViewEnums';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { ConstituentAssigneeSelect } from '@/modules/ConstituentDetails';
import userActionTypes from '@/rdx/actionTypes';
import useTaskAnalytics from '../lib/useTaskAnalytics';
import { TaskStatusEnum } from '../tasksConfig';
import TaskDisplaySelect from './TaskDisplaySelect';
import TaskFilterDialog from './TaskFilterDialog';
import TaskSortSelect from './TaskSortSelect';

function TaskListFilterControls({ filters, onFilterUpdate, isTasksPage }) {
  const dispatch = useDispatch();
  const { sendTasksListCreatedAction } = useTaskAnalytics();
  const [isFilterModalActive, setIsFilterModalActive] = React.useState(false);

  const onCreateTaskClick = () => {
    sendTasksListCreatedAction();
    dispatch({
      type: userActionTypes.OPEN_ACTION_DIALOG,
      dialogKey: MultiActionDialogKey.ADD_TASK,
    });
  };

  return (
    <>
      <div className="flex justify-between">
        {isTasksPage && (
          <BasicPageTitle
            iconSrc={addTaskIcon}
            iconAlt={translate('TASKS')}
            title={translate('TASKS')}
          />
        )}
        <div className="hidden flex-wrap items-end justify-end md:flex lg:ml-auto">
          <ConstituentAssigneeSelect
            className="ml-9 mb-2 flex w-64 md:ml-0 md:w-56 lg:ml-9"
            name="userId"
            onChange={onFilterUpdate}
            value={filters.userId || TaskStatusEnum.ALL}
          />
          <TaskDisplaySelect
            className="ml-2 mb-2 flex w-64 md:w-56 lg:ml-4"
            filters={filters}
            onFilterUpdate={onFilterUpdate}
          />
          <TaskSortSelect
            className="ml-2 mb-2 w-64 md:w-56 lg:ml-4"
            filters={filters}
            onFilterUpdate={onFilterUpdate}
          />
          <ShowForViews showFor={[UserViewEnums.ADMIN, UserViewEnums.EDITOR]}>
            <Button
              variant="contained"
              type="button"
              className="ml-2 mb-2 flex lg:ml-4"
              onClick={onCreateTaskClick}
            >
              {translate('TASKS_CREATE_TASK')}
            </Button>
          </ShowForViews>
        </div>
      </div>
      <div className="flex justify-between md:hidden">
        <TaskSortSelect
          className="mb-0 mr-2 w-full"
          filters={filters}
          onFilterUpdate={onFilterUpdate}
        />
        <FilterButton
          className="h-12"
          onClick={() => setIsFilterModalActive(true)}
          type="button"
          variant="contained"
          color="primary"
          size="small"
        />
      </div>
      <TaskFilterDialog
        filters={filters}
        onClose={() => setIsFilterModalActive(false)}
        onFilterUpdate={onFilterUpdate}
        open={isFilterModalActive}
      >
        <TaskDisplaySelect
          className="flex w-full"
          filters={filters}
          onFilterUpdate={onFilterUpdate}
        />
      </TaskFilterDialog>
    </>
  );
}

TaskListFilterControls.propTypes = {
  filters: PropTypes.shape({
    userId: PropTypes.string,
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  onFilterUpdate: PropTypes.func.isRequired,
  isTasksPage: PropTypes.bool,
};

TaskListFilterControls.defaultProps = {
  isTasksPage: false,
};

export default TaskListFilterControls;
